import { type MutableRefObject, useEffect } from "react";

// For some reason Chrome decides to show a scrollbar in the <textarea>
// and adding this to the height solves that
const EXTRA_HEIGHT = 2;

interface UseResizeableTextareaOptions {
	ref: MutableRefObject<HTMLTextAreaElement | null>;
	value: string;
	enabled: boolean;
}

export const useResizeableTextarea = ({
	enabled,
	ref,
	value,
}: UseResizeableTextareaOptions) => {
	useEffect(() => {
		if (enabled) {
			if (ref.current) {
				// We need to reset the height momentarily to get the correct scrollHeight for the textarea
				ref.current.style.height = "0px";
				const scrollHeight = ref.current.scrollHeight;

				// We then set the height directly, outside of the render loop
				// Trying to set this with state or a ref will product an incorrect value.
				ref.current.style.height = `${scrollHeight + EXTRA_HEIGHT}px`;
			}
		}
	}, [value, enabled, ref]);
};
